import React from "react";

import { connect } from "react-redux";

import { Link, Redirect } from "react-router-dom";
import logo from "logo.png";
import "./signin.css";
import API from "api";
import Axios from "axios";
import { addUser } from "store/actions/security";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        password: "",
        confirmNewPassword: "",
        kiosk: props.kioskId,
        token: props.match.params.token
      },
      error: "",
      message: "",
      submitting: false
    };
  }

  reset = e => {
    e.preventDefault();

    this.setState({ submitting: true, error: "" });
    API.resetPassword(this.state.user)
      .then(response => {
        const { data } = response;
        const { apiKey } = data;

        API.profile(apiKey).then(res => {
          const user = res.data;

          // login user;
          const expiresAt = new Date();
          user.last_login = new Date();
          expiresAt.setDate(expiresAt.getDate() + 7);
          Axios.defaults.headers.common["Authorization"] = user.api_key;
          user.accessUntil = expiresAt;

          this.setState(
            {
              error: null,
              submitting: false
            },
            () => {
              this.props.addUser(user);
            }
          );
        });
      })
      .catch(error => {
        // console.warn("error", error);
        if (error.response) {
          this.setState({
            submitting: false,
            error: error.response.data.message
          });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          //console.log(error);
          this.setState({
            submitting: false,
            error: error.message || "Error lors de la verification"
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          this.setState({ submitting: false, error: error.message });
        }
      });
  };

  handleInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    let modelName = e.target.dataset.model || null;

    let model = null;
    if (modelName) {
      model = { ...this.state[modelName] };
    }
    model[name] = value;

    this.setState({ [modelName]: model });
  };

  render() {
    const { message, error, submitting } = this.state;
    if (this.props.isAuth) {
      return (
        <Redirect
          to={{
            pathname: "/publications",
            state: { from: this.props.location }
          }}
        />
      );
    }

    return (
      <div className=" min-vh-100 d-flex  justify-content-center align-items-center">
        <div className="wrapper fadeInDown">
          <Link to="/publications">
            <img src={logo} alt="logo" className="mb-4" height="100" />
          </Link>
          <div className="formContent">
            <div className="fadeIn first">
              {/* <img
                src="http://danielzawadzki.com/codepen/01/icon.svg"
                id="icon"
                alt="User Icon"
              /> */}
            </div>

            <form
              method="post"
              className="my-3 d-flex flex-column align-items-center px-4"
              onSubmit={this.reset}
            >
              {error && <p className="text-danger text-center">{error}</p>}
              {message && <p className="text-success text-center">{message}</p>}
              <input
                type="password"
                className="fadeIn second"
                name="password"
                data-model="user"
                placeholder="Nouveu  mot de passe"
                onChange={this.handleInput}
                disabled={submitting}
              />
              <input
                type="password"
                className="fadeIn second"
                name="confirmNewPassword"
                data-model="user"
                placeholder="Confirmation Nouveau mot de passe"
                onChange={this.handleInput}
                disabled={submitting}
              />

              <button
                type="button"
                className="btn btn-ikea btn-block my-4 fadeIn fourth"
                onClick={this.reset}
                disabled={submitting}
              >
                Réinitialiser
              </button>
            </form>
            <div className="formFooter">
              <Link to="/signin" className="underlineHover">
                Connexion
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: Boolean(state.security.user)
});
const binActionsToProps = dispatch => ({
  addUser: user => dispatch(addUser(user))
});
export default connect(mapStateToProps, binActionsToProps)(ResetPassword);
